export const P00037DureeInversion = [
  { label: '2 H', ref: 2 },
  { label: '3 H', ref: 3 },
  { label: '4 H', ref: 4 },
  { label: '5 H', ref: 5 },
  { label: '6 H', ref: 6 },
  { label: '7 H', ref: 7 },
  { label: '8 H', ref: 8 },
  { label: '9 H', ref: 9 },
  { label: '10 H', ref: 10 },
  { label: '11 H', ref: 11 },
  { label: '12 H', ref: 12 },
  { label: '13 H', ref: 13 },
  { label: '14 H', ref: 14 },
  { label: '15 H', ref: 15 },
  { label: '16 H', ref: 16 },
  { label: '17 H', ref: 17 },
  { label: '18 H', ref: 18 },
  { label: '19 H', ref: 19 },
  { label: '20 H', ref: 20 },
  { label: '21 H', ref: 21 },
  { label: '22 H', ref: 22 },
  { label: '23 H', ref: 23 },
  { label: '24 H', ref: 24 },
];
